module.exports = __webpack_public_path__ + "static/img/recurring.17f5e96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cashflow-tour/recurring.png
// module id = QgHO
// module chunks = 6